export enum RecordingTags {
  SCREEN = 700,
  MASTERED = 500,
  MIXED = 300,
  FAILED = 100,
  MIGRATED = 0,
}

export const RecordingTagDisplayNames = {
  [RecordingTags.SCREEN]: 'Screen Recording',
  [RecordingTags.MASTERED]: 'Dolby Enhanced',
  [RecordingTags.MIXED]: 'Mixed',
  [RecordingTags.FAILED]: 'Failed',
  [RecordingTags.MIGRATED]: 'Migrated',
};

export const RecordingTagColors = {
  [RecordingTags.SCREEN]: 'accent-1',
  [RecordingTags.MASTERED]: 'accent-10',
  [RecordingTags.MIXED]: 'accent-orange-100',
  [RecordingTags.FAILED]: 'accent-8',
  [RecordingTags.MIGRATED]: 'accent-2',
};

export enum StatsType {
  AUDIO = 'audio',
  VIDEO = 'video',
  SCREEN = 'screen',
}

export const DAILY_RAW_TRACKS_RECORDER_INSTANCE_ID = 'a3fb419e-303c-41d3-8f3c-a9fc452179b8';
export const DAILY_CLOUD_RECORDER_INSTANCE_ID = '68883c84-3c01-417e-9d45-6762cd02bff5';
